import { render } from "./DashUser.vue?vue&type=template&id=9a47b79a"
import script from "./DashUser.vue?vue&type=script&lang=js"
export * from "./DashUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__